import { Action } from '@ngrx/store';
import { type } from '../util';
import { INDRAPrice } from '@ibe.models/booking.fare.indra.model.lib';

export const ActionTypes = {
	DISCOUNT_INFORMATION_MILES: type('[MilesBar] put discountInformationMiles'),
	DISCOUNT: type('[MilesBar] put discount'),
	PUT_HEIGHT: type('[MilesBar] put height'),
	RESET: type('[MilesBar] reset')
};

export class SetDiscountInformationMiles implements Action {
	type = ActionTypes.DISCOUNT_INFORMATION_MILES;

	/**
	 *Creates an instance of SetDiscountInformationMiles.
	 * @param {*} [payload]
	 * @memberof SetDiscountInformationMiles
	 */
	constructor(public payload: INDRAPrice) { }
}
export class SetDiscount implements Action {
	type = ActionTypes.DISCOUNT;

	/**
	 *Creates an instance of SetDiscount.
	 * @param {*} [payload]
	 * @memberof SetDiscount
	 */
	constructor(public payload: number) { }
}

export class PutHeight implements Action {
	type = ActionTypes.PUT_HEIGHT;

	/**
	 *Creates an instance of PutHeight.
	 * @param {string} payload
	 * @memberof PutHeight
	 */
	constructor(public payload: number) { }
}

export class Reset implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of Reset.
	 * @param {*} [payload]
	 * @memberof Reset
	 */
	constructor(public payload: boolean) { }
}

export type Actions = SetDiscountInformationMiles | SetDiscount | PutHeight | Reset;
